function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m464 64v336c0 17.67-14.33 32-32 32h-400c-17.67 0-32-14.33-32-32v-336c0-17.67 14.33-32 32-32h400c17.67 0 32 14.33 32 32z",
  fill: "#83f8fb"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m432.107 82h-350.107c-17.673 0-32 14.327-32 32v286.107c0 32.543-50 34.259-50-.107v-336c0-17.673 14.327-32 32-32h400c34.366 0 32.65 50 .107 50z",
  fill: "#bbfbff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m464 64v64h-464v-64c0-17.67 14.33-32 32-32h400c17.67 0 32 14.33 32 32z",
  fill: "#4d4e59"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m432.107 82h-350.107c-17.673 0-32 14.327-32 32v14h-50v-64c0-17.673 14.327-32 32-32h400c34.366 0 32.65 50 .107 50z",
  fill: "#585966"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m32.08 81.57c-.857-8.858 5.642-16.652 14.35-17.49 9.086-.96 17.57 6.222 17.57 15.92 0 8.153-6.21 15.129-14.43 15.92-8.952.862-16.665-5.742-17.49-14.35z",
  fill: "#ff6d7a"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m80.08 81.57c-.863-8.918 5.7-16.657 14.35-17.49 9.158-.968 17.57 6.329 17.57 15.92 0 8.212-6.289 15.136-14.43 15.92-8.872.854-16.658-5.663-17.49-14.35z",
  fill: "#ffec8f"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m128.08 81.57c-.856-8.852 5.644-16.652 14.35-17.49 9.126-.964 17.57 6.292 17.57 15.92 0 8.25-6.322 15.14-14.43 15.92-8.872.854-16.658-5.663-17.49-14.35z",
  fill: "#cdfdaa"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  fill: "#4d4e59"
}, /*#__PURE__*/React.createElement("path", {
  d: "m114 212.155c-8.836 0-16 7.163-16 16v28.845h-14v-28.845c0-8.837-7.164-16-16-16s-16 7.163-16 16v89.689c0 8.837 7.164 16 16 16s16-7.163 16-16v-28.844h14v28.845c0 8.837 7.164 16 16 16s16-7.163 16-16v-89.689c0-8.837-7.164-16.001-16-16.001z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m209 212h-48c-8.836 0-16 7.164-16 16s7.164 16 16 16h8v74c0 8.837 7.164 16 16 16s16-7.163 16-16v-74h8c8.836 0 16-7.164 16-16s-7.164-16-16-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m367.513 212.155h-18.203c-8.836 0-16 7.163-16 16v89.689c0 8.837 7.164 16 16 16s16-7.163 16-16v-15.654c29.3 0 46.879-21.444 46.879-45.358 0-24.635-20.041-44.677-44.676-44.677zm0 58.035h-2.203v-26.034c20.964-.001 18.009 26.034 2.203 26.034z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m303 212h-48c-8.836 0-16 7.164-16 16s7.164 16 16 16h8v74c0 8.837 7.164 16 16 16s16-7.163 16-16v-74h8c8.836 0 16-7.164 16-16s-7.164-16-16-16z"
}));

const SvgHttp = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  enableBackground: "new 0 0 464 464",
  height: 512,
  viewBox: "0 0 464 464",
  width: 512,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHttp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/http.32cfd475.svg";
export { ForwardRef as ReactComponent };